import {
  collection,
  addDoc,
  serverTimestamp,
  getFirestore,
} from "firebase/firestore";
const db = getFirestore();
export const saveTelegramLog = async () => {
  try {
    const tg = window.Telegram.WebApp;
    const user = tg.initDataUnsafe?.user;
    const tgUserId = user.id;
    await addDoc(collection(db, "telegram_emrs_log"), {
      tgUserId,
      timestamp: serverTimestamp(),
      type: "APP",
      EMRS: 0,
    });
    console.log("Log entry added successfully");
  } catch (error) {
    console.error("Error adding document: ", error);
  }
};
